import { GlobalStockSwitchResult } from './stockApiTypes';

// eslint-disable-next-line import/prefer-default-export
export const mockGlobalStockSwitchResult: GlobalStockSwitchResult = {
  clearedOfferStocks: 1286442,
  offersMarkedForUpdate: 903118,
  failedProducts: 0,
};
